import { axiosInstance } from "../helpers/axios/config";
import * as orderEndPoints from "../constants/endPoints/order";
import * as method from "../constants/requestMethods";

export const getSalesDashboardOrdersCounter = () => {
  return axiosInstance({
    url: orderEndPoints.getSalesDashboardOrdersCounter,
    method: method.GET,
  });
};

export const getAllVendorCounters = () => {
  return axiosInstance({
    url: orderEndPoints.getAllVendorCounters,
    method: method.GET,
  });
};

export const getAppStockOrdersCount = () => {
  return axiosInstance({
    url: orderEndPoints.getAppStockOrdersCount,
    method: method.GET,
  });
};

export const assignCourierToOrderItem = (data) => {
  return axiosInstance({
    url: orderEndPoints.assignCourierToOrderItem,
    method: method.POST,
    data,
  });
};

export const getRepriceNeededOrders = async (params) => {
  let response = {};

  await axiosInstance({
    method: "GET",
    url: orderEndPoints.getRepriceNeededOrders,
    params,
  })
    .then((res) => res.data)
    .then((data) => {
      response.status = "success";
      response.data = data.ordersList;
    })
    .catch((error) => {
      console.error(error);
      response.status = "failed";
      response.message = error.message;
    });
  return response;
};

export const toggleRepriceNeededOrder = async (orderId) => {
  let response = {};

  await axiosInstance({
    method: "POST",
    url: orderEndPoints.toggleRepriceNeededOrder.replace(":orderId", orderId),
  })
    .then((res) => res.data)
    .then(() => {
      response.status = "success";
    })
    .catch((error) => {
      response.status = "failed";
      response.message = error.message;
    });

  return response;
};

export const getSalesDashboardOrders = async (params) => {
  return axiosInstance({
    url: orderEndPoints.getSalesDashboardOrders,
    method: "GET",
    params,
  })
    .then((res) => res)
    .catch((err) => err);
};

export const getNeedSupportDashboardDetails = async (params) => {
  return await axiosInstance({
    url: orderEndPoints.getNeedSupportDashboardDetails,
    method: "GET",
    params,
  });
};

export const getNeedSupportDoneOrdersDetails = async () => {
  return await axiosInstance({
    url: orderEndPoints.getNeedSupportDoneOrdersDetails,
    method: "GET",
  });
};

export const getVendorSupportReturnsDetails = () => {
  return axiosInstance({
    url: orderEndPoints.getVendorSupportReturnsDetails,
    method: "GET",
  });
};

export const markReturnOrderAsNoActionNeeded = async (
  returnOrderId,
  issueDetails
) => {
  return await axiosInstance({
    url: orderEndPoints.markReturnOrderAsNoActionNeeded.replace(
      ":returnOrderId",
      returnOrderId
    ),
    method: "PUT",
    data: issueDetails,
  });
};

export const getAllOrdersPendingApproval = async (params) => {
  return axiosInstance({
    url: orderEndPoints.getAllOrdersPendingApproval,
    method: "GET",
    params,
  })
    .then((res) => res)
    .catch((err) => err);
};

export const cancelOrder = (orderId, data) => {
  return axiosInstance({
    url: `${orderEndPoints.cancelOrder}/${orderId}`,
    method: method.POST,
    data,
  });
};

export const createOrder = (data) => {
  return axiosInstance({
    url: orderEndPoints.createOrder,
    method: "POST",
    data,
  });
};

export function updateOrderItemQuantity(data) {
  return axiosInstance({
    url: orderEndPoints.UPDATE_ORDER_ITEM_QUANTITY,
    method: "PUT",
    data,
  });
}

export const getOrderDetails = (orderId) => {
  return axiosInstance({
    url: orderEndPoints.getOrderDetails.replace(":orderId", orderId),
    method: method.GET,
  });
};

export const addOrderItems = (data) => {
  return axiosInstance({
    url: orderEndPoints.addOrderItems,
    method: "POST",
    data,
  });
};

export function reallocateOrderItemSupplier(data) {
  return axiosInstance({
    url: orderEndPoints.REALLOCATE_ORDER_ITEM_SUPPLIER,
    method: "POST",
    data,
  });
}

export const getFollowUpOrderDetails = (orderId) => {
  return axiosInstance({
    url: orderEndPoints.getFollowUpOrderDetails.replace(":orderId", orderId),
    method: "GET",
  });
};

export const getMechanicNeedSupportOrderItems = () => {
  return axiosInstance({
    url: orderEndPoints.getMechanicNeedSupportOrderItems,
    method: "GET",
  });
};

export const getMechanicNeedSupportDoneOrderItems = () => {
  return axiosInstance({
    url: orderEndPoints.getMechanicNeedSupportDoneOrderItems,
    method: "GET",
  });
};

export const markMechanicSupportNeededFalse = (orderItemId, data) => {
  return axiosInstance({
    url: `${orderEndPoints.markMechanicSupportNeededFalse}/${orderItemId}`,
    method: "PUT",
    data,
  });
};

export const addMechanicNeedSupport = (orderItemId, data) => {
  return axiosInstance({
    url: `${orderEndPoints.addMechanicNeedSupportDetails}/${orderItemId}`,
    method: "POST",
    data,
  });
};

export const getMechanicVoiceOrders = (mechanicId, params) => {
  return axiosInstance({
    url: `${orderEndPoints.getAllVoiceOrders}/${mechanicId}`,
    method: "GET",
    params,
  });
};

export const getAllVoiceNotes = (params) => {
  return axiosInstance({
    url: orderEndPoints.getAllVoiceNotes,
    method: method.GET,
    params,
  });
};

export const getVoiceNoteModesWithCounters = () => {
  return axiosInstance({
    url: orderEndPoints.getVoiceNoteModesWithCounters,
    method: method.GET,
  });
};

export const getVoiceAppOrdersInQueue = (queueId, params) => {
  return axiosInstance({
    url: `${orderEndPoints.getVoiceAppOrdersInQueue}/${queueId}`,
    method: method.GET,
    params,
  });
};

export const getAllApprovedOrders = (params) => {
  return axiosInstance({
    url: orderEndPoints.getAllApprovedOrders,
    method: method.GET,
    params,
  });
};

export const getSalesDashboardSummary = (params) => {
  return axiosInstance({
    url: orderEndPoints.getSalesDashboardSummary,
    method: method.GET,
    params,
  });
};

export const updateOrderRepComment = (orderId, repComment) => {
  return axiosInstance({
    url: orderEndPoints.updateOrderRepComment,
    method: method.PUT,
    data: {
      orderId,
      repComment,
    },
  });
};

export const deleteOrderItem = (orderId, orderItemId, data) => {
  return axiosInstance({
    url: `${orderEndPoints.order}/${orderId}/${orderEndPoints.deleteOrderItem}/${orderItemId}`,
    method: method.DELETE,
    data,
  });
};

export const deleteBundleItems = (orderId, bundleId, data) => {
  return axiosInstance({
    url: orderEndPoints.deleteBundleItems
      .replace(":orderId", orderId)
      .replace(":bundleId", bundleId),
    method: method.DELETE,
    data,
  });
};

export const checkOrderTasksForCourier = (orderItemId, geoLocation) => {
  return axiosInstance({
    url: orderEndPoints.checkOrderTasksForCourier,
    method: method.POST,
    data: {
      orderItemId,
      geoLocation,
    },
  });
};

export const getVendorSupportOrderCountForAreas = () => {
  return axiosInstance({
    url: orderEndPoints.getVendorSupportOrderCountForAreas,
    method: method.GET,
  });
};

export const getVendorSupportPendingPricingOrders = (params) => {
  return axiosInstance({
    url: orderEndPoints.getVendorSupportPendingPricingOrders,
    method: method.GET,
    params,
  });
};

export const getVendorSupportPricingDoneOrders = (params) => {
  return axiosInstance({
    url: orderEndPoints.getVendorSupportPricingDoneOrders,
    method: method.GET,
    params,
  });
};

export const getOrderPricingHistory = (orderId) => {
  return axiosInstance({
    url: `${orderEndPoints.getOrderPricingHistory}/${orderId}`,
    method: method.GET,
  });
};

export const createOrderPricing = (orderId, data) => {
  return axiosInstance({
    url: `${orderEndPoints.createOrderPricing}/${orderId}`,
    method: method.POST,
    data,
  });
};

export const getSalesDashboardOrdersPendingCommunication = (params) => {
  return axiosInstance({
    url: orderEndPoints.getSalesDashboardOrdersPendingCommunication,
    method: method.GET,
    params,
  });
};

export const getSalesDashboardOrdersCommunicated = (params) => {
  return axiosInstance({
    url: orderEndPoints.getSalesDashboardOrdersCommunicated,
    method: method.GET,
    params,
  });
};

export const getVoiceAppOrdersPendingPricingCommunication = (params) => {
  return axiosInstance({
    url: orderEndPoints.getVoiceAppOrdersPendingPricingCommunication,
    method: method.GET,
    params,
  });
};

export const getVoiceAppOrdersDonePricingCommunication = (params) => {
  return axiosInstance({
    url: orderEndPoints.getVoiceAppOrdersDonePricingCommunication,
    method: method.GET,
    params,
  });
};

export const getVoiceAppOrdersModesWithCounters = () => {
  return axiosInstance({
    url: orderEndPoints.getVoiceAppOrdersModesWithCounters,
    method: method.GET,
  });
};

export const markOrderIsPriceCommunicatedAsTrue = (orderId) => {
  return axiosInstance({
    url: `${orderEndPoints.markIsPriceCommunicatedAsTrue}/${orderId}`,
    method: method.PUT,
  });
};

export const getNotYetCommunicatedToSuppliersOrders = (params) => {
  return axiosInstance({
    url: orderEndPoints.getNotYetCommunicatedToSuppliersOrders,
    method: method.GET,
    params,
  });
};

export const getSuccessfullyCommunicatedToSuppliersOrders = (params) => {
  return axiosInstance({
    url: orderEndPoints.getSuccessfullyCommunicatedToSuppliersOrders,
    method: method.GET,
    params,
  });
};

export const updateIsOrderPreparationCommunicatedAsDone = (orderId) => {
  return axiosInstance({
    url: `${orderEndPoints.updateIsOrderPreparationCommunicatedAsDone}/${orderId}`,
    method: method.PUT,
  });
};

export const getMechanicAppPricedItems = (params) => {
  return axiosInstance({
    url: orderEndPoints.getMechanicAppPricedItems,
    method: method.GET,
    params,
  });
};

export const calculateActualDeliveryFullDate = (data) => {
  return axiosInstance({
    url: orderEndPoints.calculateActualDeliveryFullDate,
    method: method.POST,
    data,
  });
};

export const createVoiceOrderFromMechanicComplaint = (data) => {
  return axiosInstance({
    url: orderEndPoints.createVoiceOrderFromMechanicComplaint,
    method: "POST",
    data,
  });
};

export const returnBundle = (data) => {
  return axiosInstance({
    url: orderEndPoints.returnBundle,
    method: method.POST,
    data,
  });
};

export const addOrderItemImages = (data, orderItemId) => {
  return axiosInstance({
    url: `${orderEndPoints.order}/${orderItemId}/${orderEndPoints.addOrderItemImages}`,
    method: method.POST,
    data,
  });
};

export const deleteOrderItemImage = (data) => {
  return axiosInstance({
    url: orderEndPoints.deleteOrderItemImage,
    method: method.DELETE,
    data,
  });
};

export const editDeliveryDate = (data) => {
  return axiosInstance({
    url: orderEndPoints.editDeliveryDate,
    method: method.POST,
    data,
  });
};

export const getAllOrdersForAssignCouriers = (params) => {
  return axiosInstance({
    url: orderEndPoints.getAllOrdersForAssignCouriers,
    method: method.GET,
    params,
  });
};

export const acceptOrder = (data) => {
  return axiosInstance({
    url: orderEndPoints.acceptOrder,
    method: method.POST,
    data,
  });
};

export const getOrderInvoiceInfo = (orderId) => {
  return axiosInstance({
    url: orderEndPoints.getOrderInvoiceInfo.replace(":orderId", orderId),
    method: method.GET,
  });
};

export const cancelReturnOrder = (returnOrderId) => {
  return axiosInstance({
    url: orderEndPoints.CANCEL_RETURN_ORDER.replace(
      ":returnOrderId",
      returnOrderId
    ),
    method: "POST",
  });
};

export const getOrderRoute = (orderId) => {
  return axiosInstance({
    url: `${orderEndPoints.getOrderRoute}/${orderId}`,
    method: method.GET,
  });
};

export function revokeOrderItemCourierAssignment(orderItemId) {
  return axiosInstance({
    url: orderEndPoints.REVOKE_ORDER_ITEM_COURIER_ASSIGNMENT.replace(
      ":orderItemId",
      orderItemId
    ),
    method: "POST",
  });
}

export function revokeReturnOrderCourierAssignment(returnOrderId) {
  return axiosInstance({
    url: orderEndPoints.REVOKE_RETURN_ORDER_COURIER_ASSIGNMENT.replace(
      ":returnOrderId",
      returnOrderId
    ),
    method: "POST",
  });
}

export const updateOrderItemReturnQuantityV2 = (data) => {
  return axiosInstance({
    url: orderEndPoints.updateOrderItemReturnQuantityV2,
    method: method.POST,
    data,
  });
};

export const revokeBundleCourierAssignment = (orderId, bundleId) => {
  return axiosInstance({
    url: orderEndPoints.revokeBundleCourierAssignment
      .replace(":orderId", orderId)
      .replace(":bundleId", bundleId),
    method: method.POST,
  });
};

export const assignCourierToBundle = (data) => {
  return axiosInstance({
    url: orderEndPoints.assignCourierToBundle,
    method: method.POST,
    data,
  });
};

export const getOrderProfile = (orderId) => {
  return axiosInstance({
    url: `${orderEndPoints.getOrderProfile}/${orderId}`,
    method: method.GET,
  });
};

export const assignCourierToReturnOrder = (data) => {
  return axiosInstance({
    url: orderEndPoints.assignCourierToReturnOrder,
    method: method.POST,
    data,
  });
};

export const assignCourierToReturnBundle = (data) => {
  return axiosInstance({
    url: orderEndPoints.assignCourierToReturnBundle,
    method: method.POST,
    data,
  });
};

export const revokeReturnBundleCourierAssignment = (returnOrderId) => {
  return axiosInstance({
    url: `${orderEndPoints.revokeReturnBundleCourierAssignment}/${returnOrderId}`,
    method: method.POST,
  });
};

export const cancelReturnBundle = (returnOrderId) => {
  return axiosInstance({
    url: `${orderEndPoints.cancelReturnBundle}/${returnOrderId}`,
    method: method.POST,
  });
};

export const markMechanicSupportNeededFalseForBundle = (orderId, bundleId) => {
  return axiosInstance({
    url: orderEndPoints.markMechanicSupportNeededFalseForBundle
      .replace(":orderId", orderId)
      .replace(":bundleId", bundleId),
    method: method.PUT,
  });
};

export const markReturnOrderIsActionNeededFalseForBundle = (
  returnOrderId,
  data
) => {
  return axiosInstance({
    url: orderEndPoints.markReturnOrderIsActionNeededFalseForBundle.replace(
      ":returnOrderId",
      returnOrderId
    ),
    method: method.PUT,
    data,
  });
};

export const reallocateBundleSupplier = (data) => {
  return axiosInstance({
    url: orderEndPoints.reallocateBundleSupplier,
    method: method.POST,
    data,
  });
};

export const acceptPricedOrder = (orderId, data) => {
  return axiosInstance({
    url: orderEndPoints.acceptPricedOrder.replace(":orderId", orderId),
    method: method.POST,
    data,
  });
};

export const getParentOrdersProfile = (orderId) => {
  return axiosInstance({
    url: orderEndPoints.getParentOrdersProfile.replace(":orderId", orderId),
    method: method.GET,
  });
};

export const cancelParentOrder = (orderId, data) => {
  return axiosInstance({
    url: orderEndPoints.cancelParentOrder.replace(":orderId", orderId),
    method: method.POST,
    data,
  });
};

export const getParentOrders = (params) => {
  return axiosInstance({
    url: orderEndPoints.getParentOrders,
    method: method.GET,
    params,
  });
};

export const deleteOrderItemParent = (data) => {
  return axiosInstance({
    url: orderEndPoints.deleteOrderItemParent,
    method: method.DELETE,
    data,
  });
};

export const assignCourierToOrder = (data) => {
  return axiosInstance({
    url: orderEndPoints.assignCourierToOrder,
    method: method.POST,
    data,
  });
};

export function revokeOrderCourierAssignment(orderId) {
  return axiosInstance({
    url: orderEndPoints.revokeOrderCourierAssignment.replace(
      ":orderId",
      orderId
    ),
    method: method.POST,
  });
}

export function reallocateOrderSupplier(data) {
  return axiosInstance({
    url: orderEndPoints.reallocateOrderSupplier,
    method: method.POST,
    data,
  });
}

export const getOrderInvoiceInfoForCourier = (orderId, params) => {
  return axiosInstance({
    url: orderEndPoints.getOrderInvoiceInfoForCourier.replace(
      ":orderId",
      orderId
    ),
    method: method.GET,
    params,
  });
};

export const markOrderAsSupportNeeded = (orderId, data) => {
  return axiosInstance({
    url: orderEndPoints.markOrderAsSupportNeeded.replace(":orderId", orderId),
    method: method.PUT,
    data,
  });
};

export const getAllOrderItemNames = () => {
  return axiosInstance({
    url: orderEndPoints.getAllOrderItemNames,
    method: method.GET,
  });
};

export const getSaleOrderInvoiceInfo = (orderId, warehouseId) => {
  return axiosInstance({
    url: orderEndPoints.getSaleOrderInvoiceInfo
      .replace(":orderId", orderId)
      .replace(":warehouseId", warehouseId),
    method: method.GET,
  });
};

export const updateOrderIsSupportNeeded = (orderId, data) => {
  return axiosInstance({
    url: orderEndPoints.updateOrderIsSupportNeeded.replace(":orderId", orderId),
    method: method.PUT,
    data,
  });
};

export const markVoiceOrderAsCreated = (orderId) => {
  return axiosInstance({
    url: orderEndPoints.markVoiceOrderAsCreated.replace(":orderId", orderId),
    method: method.PUT,
  });
};

export const getAllFailedToReturnOrders = () => {
  return axiosInstance({
    url: orderEndPoints.getAllFailedToReturnOrders,
    method: method.GET,
  });
};

export const getMechanicOrdersDetailsGivenMechanicId = (mechanicId, params) => {
  return axiosInstance({
    url: orderEndPoints.getMechanicOrdersDetailsGivenMechanicId.replace(
      ":mechanicId",
      mechanicId
    ),
    method: method.GET,
    params,
  });
};

export const getAllOrderItemsByOrderIdAndSupplierId = (orderId, supplierId) => {
  return axiosInstance({
    url: orderEndPoints.getAllOrderItemsByOrderIdAndSupplierId
      .replace(":orderId", orderId)
      .replace(":supplierId", supplierId),
    method: method.GET,
  });
};

export const summary = (params) => {
  return axiosInstance({
    url: orderEndPoints.summary,
    method: method.GET,
    params,
  });
};

export const getAllOrders = (params) => {
  return axiosInstance({
    url: orderEndPoints.order,
    method: method.GET,
    params,
  });
};

export const getSupplierTodayOrders = (supplierId) => {
  return axiosInstance({
    url: orderEndPoints.getSupplierTodayOrders.replace(
      ":supplierId",
      supplierId
    ),
    method: method.GET,
  });
};

export const getAllReturnOrdersForQuality = (params) => {
  return axiosInstance({
    url: orderEndPoints.getAllReturnOrdersForQuality,
    method: method.GET,
    params,
  });
};

export const getAllOrderItemPricingHistory = (params) => {
  return axiosInstance({
    url: orderEndPoints.getAllOrderItemPricingHistory,
    method: method.GET,
    params,
  });
};

export const getReturnOrders = (params) => {
  return axiosInstance({
    url: orderEndPoints.getReturnOrders,
    method: method.GET,
    params,
  });
};

export const getOpFormOrderDetails = (orderId) => {
  return axiosInstance({
    url: orderEndPoints.getOpFormOrderDetails.replace(":orderId", orderId),
    method: method.GET,
  });
};

export const pickUpOrderItem = (orderItemId) => {
  return axiosInstance({
    url: orderEndPoints.pickUpOrderItem.replace(":orderItemId", orderItemId),
    method: method.PUT,
  });
};

export const markOrderItemAsNotAvailable = (orderItemId, data) => {
  return axiosInstance({
    url: orderEndPoints.markOrderItemAsNotAvailable.replace(
      ":orderItemId",
      orderItemId
    ),
    method: method.POST,
    data,
  });
};

export const updateOrderItemAsSold = (data) => {
  return axiosInstance({
    url: orderEndPoints.updateOrderItemAsSold,
    method: method.POST,
    data,
  });
};

export const fulfillOrder = (orderId, data) => {
  return axiosInstance({
    url: orderEndPoints.markOrderItemAsNotAvailable.replace(
      ":orderId",
      orderId
    ),
    method: method.POST,
    data,
  });
};
export function editOpsNeedSupportReason(data) {
  return axiosInstance({
    url: orderEndPoints.editOpsNeedSupportReason,
    method: "PUT",
    data,
  });
}

export function editMechanicNeedSupportReason(data) {
  return axiosInstance({
    url: orderEndPoints.editMechanicNeedSupportReason,
    method: "PUT",
    data,
  });
}

export function editMechanicNeedSupportReasonForBundle(data) {
  return axiosInstance({
    url: orderEndPoints.editMechanicNeedSupportReasonForBundle,
    method: "PUT",
    data,
  });
}

export function generateQrCodeForOrder(saleOrderId) {
  return axiosInstance({
    url: orderEndPoints.generateQrCodeForOrder.replace(
      ":saleOrderId",
      saleOrderId
    ),
    method: method.POST,
  });
}
export const getSaleOrdersInvoiceInfo = (params, warehouseId) => {
  return axiosInstance({
    url: orderEndPoints.getSaleOrdersInvoiceInfo.replace(
      ":warehouseId",
      warehouseId
    ),
    method: method.GET,
    params,
  });
};

export const editInstaPartsDeliveryDate = (data) => {
  return axiosInstance({
    url: orderEndPoints.editInstaPartsDeliveryDate,
    method: method.POST,
    data,
  });
};

export const calculateInstaPartsActualDeliveryFullDate = (orderId) => {
  return axiosInstance({
    url: orderEndPoints.calculateInstaPartsActualDeliveryFullDate.replace(
      ":orderId",
      orderId
    ),
    method: method.POST,
  });
};

export function editMechanicNeedSupportOutput(data) {
  return axiosInstance({
    url: orderEndPoints.editMechanicNeedSupportOutput,
    method: "PUT",
    data,
  });
}

export function editOpsNeedSupportOutput(data) {
  return axiosInstance({
    url: orderEndPoints.editOpsNeedSupportOutput,
    method: "PUT",
    data,
  });
}
export function editVnStatus(data) {
  return axiosInstance({
    url: orderEndPoints.editVnStatus,
    method: "PUT",
    data,
  });
}

export function editMechanicNeedSupportOutputForBundle(data) {
  return axiosInstance({
    url: orderEndPoints.editMechanicNeedSupportOutputForBundle,
    method: "PUT",
    data,
  });
}

export function getConsignmentOrdersSummary(inventorySupplierId, params) {
  return axiosInstance({
    url: orderEndPoints.getConsignmentOrdersSummary.replace(
      ":inventorySupplierId",
      inventorySupplierId
    ),
    method: method.GET,
    params,
  });
}

export function getAllConsignmentOrdersForDispatching(
  inventorySupplierId,
  params
) {
  return axiosInstance({
    url: orderEndPoints.getAllConsignmentOrdersForDispatching.replace(
      ":inventorySupplierId",
      inventorySupplierId
    ),
    method: method.GET,
    params,
  });
}

export const getConsignmentOrderInvoiceInfo = (params, warehouseId) => {
  return axiosInstance({
    url: orderEndPoints.getConsignmentOrderInvoiceInfo.replace(
      ":warehouseId",
      warehouseId
    ),
    method: method.GET,
    params,
  });
};
